import { Modal } from "react-bootstrap";
import seccessImage from "../../styles/images/success-tick-logo.svg";

const SuccessAlertModal = (props) => {
  return (
    <Modal
      className="forgotPasswordModal"
      show={props.show}
      onHide={() => props.handleClose}
      backdrop="static"
    >
      <div className="me-2"></div>
      <div className="d-flex flex-column align-items-end me-2">
        <button
          type="button"
          className="btn-reset-custom"
          aria-label="Close"
          data-dismiss="modal"
          onClick={() => props.handleClose()}
        ></button>
      </div>
      <Modal.Body>
        <div className="">
          <img src={seccessImage} alt="seccessImage" />
        </div>
        <div className="modalHeading">Success</div>
        <div className="modalText mt-2">
          {/* Great! You’ve Updated user successfully. */}
          {props.msg}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessAlertModal;